export default __webpack_public_path__ + "static/media/powered-by-af.6e0bc647.svg";